/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Api_Reference_Errors_HelpInputs */

const en_directory_api_reference_errors_help = /** @type {(inputs: Directory_Api_Reference_Errors_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stable machine codes — only ever added, never redefined.`)
};

const zh_directory_api_reference_errors_help = /** @type {(inputs: Directory_Api_Reference_Errors_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稳定的机器码——只增不改义。`)
};

/**
* | output |
* | --- |
* | "Stable machine codes — only ever added, never redefined." |
*
* @param {Directory_Api_Reference_Errors_HelpInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_api_reference_errors_help = /** @type {((inputs?: Directory_Api_Reference_Errors_HelpInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Api_Reference_Errors_HelpInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_api_reference_errors_help(inputs)
	return zh_directory_api_reference_errors_help(inputs)
});
export { directory_api_reference_errors_help as "directory.api_reference.errors_help" }